import {actions as A} from '../constants/actions';

export const clearInspectionData = () => dispatch => {
  return dispatch({
    type: A.CLEAR_INSPECTION
  })
};
